import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowPathRoundedSquareIcon, ArrowUpRightIcon } from '@heroicons/react/24/outline';

import useServerArea from '../../api/useServerArea';
import SpinnerLoading from './SpinnerLoading';

const PendingDispatch = ({ businessId }: { businessId: number }) => {
  const { getTotalPendingDispatch, pendingDispatchCount, isLoading } =
    useServerArea()
  const navigate = useNavigate()

  useEffect(() => {
    getTotalPendingDispatch(businessId)
  }, [])

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-bold text-gray-900">
            Despachos pendientes
          </h1>
          <ArrowPathRoundedSquareIcon className="h-6 animate-pulse" />
        </div>
        <button
          onClick={() =>
            navigate('stocks/dispatches', {
              state: { filter: { status: 'CREATED' } },
            })
          }
        >
          <ArrowUpRightIcon className="h-5 font-semibold" />
        </button>
      </div>
      <div className="flex h-48 items-center justify-center border border-gray-200 bg-white">
        {isLoading ? (
          <SpinnerLoading />
        ) : (
          <div className="flex w-full items-center justify-center">
            <span className="tracking-tigh text-7xl font-semibold">
              {pendingDispatchCount}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default PendingDispatch
